import Layout from '@/layout'
const systemRouter = {
  path: '/System',
  component: Layout,
  redirect: '/System/User',
  name: 'System',
  alwaysShow: true,
  meta: {
    title: '系统管理',
    icon: 'System'
  },
  children: [
    {
      path: "/System/User",
      name: "User",
      component: () => import("@/views/System/User/index.vue"),
      meta: {
        title: "用户管理",
      }
    },
    {
      path: "/System/Roles",
      name: "Roles",
      component: () => import("@/views/System/Roles/index.vue"),
      meta: {
        title: "角色管理",
      }
    },
    {
      path: "/System/AuditFlow",
      name: "AuditFlow",
      component: () => import("@/views/System/AuditFlow/index.vue"),
      meta: {
        title: "流程管理",
      }
    },
    //   {
    //    path: "/System/Department",
    //    name: "Department",
    //    component: () => import("@/views/System/Department/index.vue"),
    //    meta: {
    //      title: "部门管理",
    //    }
    //  },
  ]
}

export default systemRouter;